module.exports = __webpack_public_path__ + "static/media/crop-alt.b854b460.svg";